/**
 * Admin nav — single source of truth for the sidebar groups.
 *
 * Rendered by AdminLayout in two places (same content): the persistent
 * desktop sidebar and the mobile off-canvas drawer. Grouping is by what the
 * operator DOES — Overview (glance), People (the three personas), Operations
 * (the daily queues to action), Billing & rates (config + AR monitoring),
 * System (trail + own account). Adding an admin page = one line here.
 */
export interface AdminNavItem {
  to: string;
  label: string;
  /** Match this route exactly for the active state — only `/` needs it, so a
   *  sub-route doesn't light up Dashboard too. */
  exact?: boolean;
}

export interface AdminNavGroup {
  label: string;
  items: readonly AdminNavItem[];
}

export const ADMIN_NAV_GROUPS: readonly AdminNavGroup[] = [
  {
    label: 'Overview',
    items: [
      { to: '/', label: 'Dashboard', exact: true },
      { to: '/map', label: 'Service map' },
    ],
  },
  {
    label: 'Marketplace',
    items: [
      { to: '/caregivers', label: 'Professionals' },
      { to: '/facilities', label: 'Facilities' },
      { to: '/homecare-clients', label: 'Families' },
    ],
  },
  {
    label: 'Operations',
    items: [
      { to: '/vetting', label: 'Vetting' },
      { to: '/compliance', label: 'Compliance' },
      { to: '/shift-requests', label: 'Shifts' },
      { to: '/payouts', label: 'Payouts' },
      { to: '/notifications', label: 'Notifications' },
      { to: '/contact-submissions', label: 'Contact forms' },
    ],
  },
  {
    label: 'Billing & rates',
    items: [
      { to: '/rates', label: 'Rates' },
      { to: '/policies', label: 'Policies' },
      { to: '/agreements', label: 'Agreements' },
      { to: '/billing/ar-aging', label: 'AR aging' },
    ],
  },
  {
    label: 'System',
    items: [
      { to: '/audit', label: 'Audit' },
      { to: '/operators', label: 'Operators' },
      // 'My profile' (/me) now lives in the top-right account menu (Phase 17).
    ],
  },
];
